<template>
	<div class="purchase-container">
		<div class="purchase-page">
			<!-- 标题 -->
			<div class="purchase-title">
				<span class="title-icon"></span>
				<span class="title-text">购买流程</span>
			</div>

			<!-- 内容区域 -->
			<div class="purchase-content">
				<!-- 流程页签 -->
				<div class="step-tabs">
					<div v-for="(step, index) in stepList" :key="index" :class="['step-tab', { active: currentStep === index }]">
						<i :class="['step-icon', step.icon]"></i>
						<span class="step-name">{{ step.name }}</span>
					</div>
				</div>

				<!-- 步骤内容区域 -->
				<div class="step-content">
					<!-- 第一步：展示信息 -->
					<div v-show="currentStep === 0" class="step-panel">
						<display-info
							ref="displayInfoRef"
							:business-id="businessId"
							:display-sector-type="displaySectorType"
							:resubmit="resubmit"
						/>
					</div>

					<!-- 第二步：详情页信息 -->
					<div v-show="currentStep === 1" class="step-panel">
						<detail-info ref="detailInfoRef" :business-id="businessId" :resubmit="resubmit" />
					</div>

					<!-- 第三步：支付 -->
					<div v-show="currentStep === 2" class="step-panel">
						<payment-info ref="paymentRef" />
					</div>
				</div>

				<!-- 温馨提示弹窗 -->
				<tips-dialog :visible.sync="tipsVisible" @confirm="handleTipsConfirm" />

				<!-- 步骤按钮 -->
				<div class="step-actions">
					<el-button v-if="currentStep > 0" type="primary" plain class="action-btn" @click="handlePrev">
						上一步
					</el-button>
					<el-button v-if="currentStep <= stepList.length - 1" type="primary" class="action-btn" @click="handleNext">
						下一步
					</el-button>
					<el-button class="action-btn" @click="handleCancel">取消</el-button>
					<!-- <el-button type="primary" class="action-btn" @click="handleConfirm">
						确认
					</el-button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * @description 应用商城-购买流程页面
	 */
	import DisplayInfo from './components/DisplayInfo.vue'
	import DetailInfo from './components/DetailInfo.vue'
	import Payment from './components/Payment.vue'
	import TipsDialog from './components/TipsDialog.vue'
	import { getUuid } from '@/utils'
	import { submitMerchantOrder } from '@/api/mall/index.js'
	import { DISPLAY_SECTOR, ENUM_DISPLAY_SECTOR } from '@/enum/index.js'

	export default {
		name: 'MallPurchase',
		components: {
			DisplayInfo,
			DetailInfo,
			PaymentInfo: Payment,
			TipsDialog
		},
		props: {},
		data() {
			return {
				// 展示板块（1：企业宣传；2：企业风采）
				displaySectorType: '',
				// 当前步骤索引
				currentStep: 0,
				// 步骤列表
				stepList: [
					{ name: '展示信息', icon: 'iconfont icon-peixun' },
					{ name: '详情页信息', icon: 'iconfont icon-jilu' }
					// { name: '支付', icon: 'iconfont icon-daizhifu' }
				],
				// 各步骤表单数据
				formData: {
					displayInfo: {},
					detailInfo: {},
					payment: {}
				},
				// 订单提交数据
				orderFormData: {},
				// 页面级业务ID，进入页面时自动生成
				businessId: '',
				// 是否重新提交
				resubmit: false,
				// 温馨提示弹窗显示状态
				tipsVisible: false
			}
		},
		computed: {},
		watch: {},
		created() {
			// 从URL参数中获取展示板块类型，验证是否在枚举范围内，不在则取默认值
			const urlType = this.$route.query.displaySectorType
			this.displaySectorType = ENUM_DISPLAY_SECTOR[urlType] ? urlType : DISPLAY_SECTOR.COMPANY_PROPAGANDA

			const orderId = this.$route.query.orderId

			if (orderId) {
				this.businessId = orderId
				this.resubmit = true
			} else {
				// 每次进入购买页面自动生成新的业务ID
				this.businessId = getUuid()
			}
		},
		mounted() {},
		methods: {
			// 上一步
			handlePrev() {
				if (this.currentStep > 0) {
					this.currentStep--
				}
			},
			// 下一步
			async handleNext() {
				// 校验当前步骤表单
				try {
					if (this.currentStep === 0) {
						const data = await this.$refs.displayInfoRef.validate()
						this.formData.displayInfo = { ...data }
					} else if (this.currentStep === 1) {
						const data = await this.$refs.detailInfoRef.validate()
						this.formData.detailInfo = { ...data }

						this.$modal
							.confirm('请确认内容填写无误，是否为您创建订单？', '温馨提示', {
								confirmButtonText: '确定',
								cancelButtonText: '再想想',
								type: 'warning'
							})
							.then(async () => {
								console.log('购买确认')
								const submitData = {
									...this.formData.displayInfo,
									...this.formData.detailInfo,
									orderId: this.businessId
								}
								console.log('提交数据:', submitData)
								await submitMerchantOrder(submitData)
								// 跳转至订单列表页面
								this.$router.push('/user/shoppmanag/shoppOrder')
							})
							.catch(() => {
								console.log('购买取消')
							})
					}
					if (this.currentStep < this.stepList.length - 1) {
						this.currentStep++
					}
				} catch (error) {
					console.error('表单校验失败:', error)
				}
			},
			// 取消
			handleCancel() {
				this.$modal
					.confirm('确定要取消购买吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '再想想',
						type: 'warning'
					})
					.then(() => {
						// 返回商城首页
						this.$router.push('/mall/index')
					})
					.catch(() => {})
			},
			// 确认：先校验支付表单，再显示温馨提示弹窗
			async handleConfirm() {
				try {
					// 校验支付组件表单
					// const paymentData = await this.$refs.paymentRef.validate()
					// 显示温馨提示弹窗
					// this.tipsVisible = true
				} catch (error) {
					console.error('表单校验失败:', error)
				}
			},
			// 弹窗点击"知道了"后执行实际提交
			async handleTipsConfirm() {
				try {
					const submitData = {
						...this.formData.displayInfo,
						...this.formData.detailInfo,
						orderId: this.businessId
					}
					console.log('提交数据:', submitData)
					await submitMerchantOrder(submitData)
					// 跳转至订单列表页面
					this.$router.push('/user/shoppmanag/shoppOrder')
				} catch (error) {
					console.error('提交失败:', error)
					this.$message.error('提交失败，请检查表单信息')
				}
			}
		}
	}
</script>

<style lang="scss">
	@import './purchase.scss';
</style>
